import { ERentioFormField } from "../../components/components/Form";
import { CONFIG } from "../../config/app.config";
import { getIbans } from "../../redux/contact/contact.actions";
import * as contactSelectors from "../../redux/contact/contact.selectors";
import { getValue, ibanSelectInlineValueSelector, } from "../../redux/form/form.utils";
import { EPaymentOrderType } from "../../types/payment.types";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { getReference } from "./schema.createPayment.6.utils";
import { EField } from "./schema.createPayment.types";
import { getNavigationTitle, getStartDate } from "./schema.createPayment.utils";
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a;
        return {
            required: [EField.CommissionIban, EField.CommissionPayoutReferenceType],
            properties: (_a = {},
                _a[EField.Header + "9"] = {
                    default: undefined,
                },
                _a[EField.CommissionIban] = {
                    default: getValue(EField.CommissionIban, initialValues, defaultValues),
                },
                _a[EField.CommissionPayoutReferenceType] = {
                    default: getValue(EField.CommissionPayoutReferenceType, initialValues, defaultValues),
                    // @ts-ignore
                    options: ["DEFAULT", "CUSTOM"].map(function (id) { return ({
                        id: id,
                        value: getLocalizedText("payment.payment_order.payout_reference_type.".concat(id).toLowerCase()),
                    }); }),
                },
                _a[EField.CommissionPayoutReference] = {
                    default: getValue(EField.CommissionPayoutReference, initialValues, defaultValues),
                    maxLength: 10,
                    // @ts-ignore
                    showIf: function (formData) {
                        return formData[EField.CommissionPayoutReferenceType] !== "CUSTOM";
                    },
                },
                _a[EField.CommissionPayoutReferenceCustom] = {
                    default: getValue(EField.CommissionPayoutReferenceCustom, initialValues, defaultValues),
                    maxLength: 106,
                    // @ts-ignore
                    showIf: function (formData) {
                        return formData[EField.CommissionPayoutReferenceType] === "CUSTOM";
                    },
                    requiredIf: function (formData) {
                        return formData[EField.CommissionPayoutReferenceType] === "CUSTOM";
                    },
                },
                _a),
        };
    };
};
export var uiSchema = function (extraData) {
    var _a;
    return (_a = {
            "rentio:title": getLocalizedText("payment.payment_order.commission_iban.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData)
        },
        _a[EField.Header + "9"] = {
            "ui:field": ERentioFormField.SectionHeader,
            getTitle: function () {
                return getLocalizedText("payment.payment_order.commission_iban.heading");
            },
        },
        _a[EField.CommissionIban] = {
            "ui:field": ERentioFormField.IbanSelectInline,
            title: getLocalizedText("payment.payment_order.commission_iban.field"),
            addIbanCtaTitle: getLocalizedText("payment.payment_order.iban.add.cta"),
            valueSelector: function (state, input) {
                return ibanSelectInlineValueSelector(state, input);
            },
            accountIdToAddIban: function (formData) { var _a; return (_a = formData[EField.CommissionPayee]) === null || _a === void 0 ? void 0 : _a[0]; },
            customIsFetchingSelector: function (state, formData) {
                var _a;
                return contactSelectors.isFetchingIbans(state, undefined, (_a = formData[EField.CommissionPayee]) === null || _a === void 0 ? void 0 : _a[0]);
            },
            customIbansSelector: function (state, formData) {
                var _a;
                return contactSelectors.getIbans(state, undefined, (_a = formData[EField.CommissionPayee]) === null || _a === void 0 ? void 0 : _a[0]);
            },
            customGetIbansActions: function (formData) { return [
                function () {
                    var _a;
                    return getIbans.actions.start({
                        accountId: (_a = formData[EField.CommissionPayee]) === null || _a === void 0 ? void 0 : _a[0],
                    });
                },
            ]; },
        },
        _a[EField.CommissionPayoutReferenceType] = {
            "ui:field": ERentioFormField.DropdownSelect,
            title: getLocalizedText("payment.payment_order.payout_reference_type.label"),
            formatSummary: function (input) {
                return input
                    ? getLocalizedText("payment.payment_order.payout_reference_type.".concat(input).toLowerCase())
                    : "";
            },
        },
        _a[EField.CommissionPayoutReference] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("payment.payment_order.payout_reference.label"),
            placeholder: getLocalizedText("payment.payment_order.payout_reference.placeholder"),
            info: getLocalizedText("payment.payment_order.payout_reference.info"),
            extraInfoUrl: getLocalizedText("payment.payment_order.payout_reference.url"),
            optional: true,
            getIMaskProps: function (formData) { return ({
                mask: getReference({
                    asMask: true,
                    property: extraData.property,
                    paymentOrderType: EPaymentOrderType.BrokerFee,
                    startDate: getStartDate(formData),
                }),
                placeholderChar: ". ",
                prepare: function (input) { return input.toUpperCase(); },
                lazy: false,
                unmask: true,
            }); },
            formatSummary: function (value, formData) {
                return getReference({
                    asMask: false,
                    reference: value,
                    property: extraData.property,
                    paymentOrderType: EPaymentOrderType.BrokerFee,
                    startDate: getStartDate(formData),
                }).toUpperCase();
            },
        },
        _a[EField.CommissionPayoutReferenceCustom] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("payment.payment_order.payout_reference_custom.label"),
            placeholder: getLocalizedText("payment.payment_order.payout_reference_custom.placeholder"),
            info: getLocalizedText("payment.payment_order.payout_reference_custom.info"),
            // extraInfoUrl: getLocalizedText(
            //   "payment.payment_order.payout_reference_custom.url",
            // ),
        },
        _a);
};
export var getValidate = function (_) { return function (formData, errors) {
    if (errors[EField.CommissionPayoutReference]) {
        var payoutReference = (formData[EField.CommissionPayoutReference] ||
            "");
        if (payoutReference.length > 0) {
            // Contains only alphanumeric characters & space
            var isValid = CONFIG.PAYOUT_REFERENCE_REGEX.test(payoutReference);
            if (!isValid) {
                errors[EField.CommissionPayoutReference].addError(getLocalizedText("payment.payment_order.payout_reference.error.no_special_characters"));
            }
        }
    }
    if (errors[EField.CommissionPayoutReferenceCustom]) {
        var payoutReference = (formData[EField.CommissionPayoutReferenceCustom] || "");
        if (payoutReference.length > 0) {
            // Contains only alphanumeric characters & space
            var isValid = CONFIG.PAYOUT_REFERENCE_REGEX.test(payoutReference);
            if (!isValid) {
                errors[EField.CommissionPayoutReferenceCustom].addError(getLocalizedText("payment.payment_order.payout_reference.error.no_special_characters"));
            }
        }
    }
    return errors;
}; };
